import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const BookmarkModal = ({ isOpen, onClose, onSave, initialNote = '' }) => {
  const [note, setNote] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setNote(initialNote);
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }
  }, [isOpen, initialNote]);

  const handleSave = () => {
    onSave(note);
    setNote('');
    onClose();
  };

  const handleClose = () => {
    setNote('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-slate-800 rounded-lg shadow-xl w-96 border border-slate-700">
        <div className="p-4">
          <h3 className="font-semibold mb-2 text-white">
            {initialNote ? 'Edit Bookmark Note' : 'Add Bookmark Note'}
          </h3>
          <textarea
            ref={textareaRef}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="w-full bg-slate-900 border border-slate-600 rounded p-2 text-sm text-white mb-4 h-24 focus:ring-1 focus:ring-blue-500 focus:outline-none"
            placeholder="Why is this line important?"
          />
          <div className="flex justify-end gap-2">
            <button
              onClick={handleClose}
              className="px-3 py-1.5 text-slate-300 text-sm hover:bg-slate-700 rounded"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-3 py-1.5 bg-yellow-600 hover:bg-yellow-700 text-white text-sm rounded"
            >
              {initialNote ? 'Update' : 'Save Bookmark'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

BookmarkModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  initialNote: PropTypes.string
};

export default BookmarkModal;

